import { getPipelineListGql, startPipelineGql } from '@/graphql/gql/pipeline';
import { calVariables, request } from '@/graphql/util';

export async function getPipelineList(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(getPipelineListGql, data),
  });
  return result;
}

export async function startPipeline(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(startPipelineGql, data),
  });
  return result;
}
